/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_ImportInputs */

const en_confirm_import = /** @type {(inputs: Confirm_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm Import`)
};

const fr_confirm_import = /** @type {(inputs: Confirm_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmer l'importation`)
};

const de_confirm_import = /** @type {(inputs: Confirm_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import bestätigen`)
};

const it_confirm_import = /** @type {(inputs: Confirm_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conferma importazione`)
};

const ru_confirm_import = /** @type {(inputs: Confirm_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердить импорт`)
};

const es_confirm_import = /** @type {(inputs: Confirm_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar importación`)
};

const zh_cn2_confirm_import = /** @type {(inputs: Confirm_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认进口`)
};

const ja_confirm_import = /** @type {(inputs: Confirm_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インポートの確認`)
};

const hi_confirm_import = /** @type {(inputs: Confirm_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात की पुष्टि करें`)
};

const pt_pt2_confirm_import = /** @type {(inputs: Confirm_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar importação`)
};

/**
* | output |
* | --- |
* | "Confirm Import" |
*
* @param {Confirm_ImportInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const confirm_import = /** @type {((inputs?: Confirm_ImportInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_ImportInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_confirm_import(inputs)
	if (locale === "de") return de_confirm_import(inputs)
	if (locale === "it") return it_confirm_import(inputs)
	if (locale === "ru") return ru_confirm_import(inputs)
	if (locale === "es") return es_confirm_import(inputs)
	if (locale === "zh-CN") return zh_cn2_confirm_import(inputs)
	if (locale === "ja") return ja_confirm_import(inputs)
	if (locale === "hi") return hi_confirm_import(inputs)
	if (locale === "pt-PT") return pt_pt2_confirm_import(inputs)
	return en_confirm_import(inputs)
});